/*--------------------------------------------------------------
# Custom scripts for FAQs block
--------------------------------------------------------------*/

// get the accordion collapse which we will focus on when clicked
let accordionItemsToBeFocused = document.querySelectorAll(".accordion-collapse");

// function to check if an element is visible on the screen
function isElementVisible(el) {
    const rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

// when each collapse is clicked, scroll to this specific collapse in the page if it's not visible
accordionItemsToBeFocused.forEach((el) => {
    // hook into Bootstrap event
    el.addEventListener('shown.bs.collapse', (e) => {
        // check if the element is not visible on the screen
        if (!isElementVisible(el)) {
            // go to the location of the collapse with the relevant ID
            window.location.href = '#' + el.id;
        }
    });
});